/**
 * Browser Specific Help Component
 * Renders browser-specific instructions with visual guides
 */

import React from 'react'
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
  Paper,
} from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { InstructionVisuals } from './InstructionVisuals'
import { getQuickHelp, getBrowserHelpURL } from 'src/services/mediaPermissions'

export const BrowserSpecificHelp = ({
  recoveryPlan,
  showVisuals = true,
  compact = false,
}) => {
  if (!recoveryPlan) return null

  const { instructions, visuals, quickHelp, helpURL } = recoveryPlan

  const openHelpURL = () => {
    window.open(helpURL, '_blank', 'noopener,noreferrer')
  }

  if (compact) {
    return (
      <Box>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {quickHelp || getQuickHelp()}
        </Typography>
        <Button
          size="small"
          startIcon={<OpenInNewIcon />}
          onClick={openHelpURL}
          sx={{ mt: 1 }}
        >
          Detailed Instructions
        </Button>
      </Box>
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      {/* Quick help */}
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 3,
          backgroundColor: '#e3f2fd',
          border: '1px solid #90caf9',
          borderRadius: 2,
        }}
      >
        <Typography variant="body1" fontWeight="medium" color="primary">
          Quick Tip:
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {quickHelp || getQuickHelp()}
        </Typography>
      </Paper>

      {/* Visual instructions */}
      {showVisuals && visuals && visuals.length > 0 && (
        <InstructionVisuals visuals={visuals} />
      )}

      {/* Step-by-step instructions */}
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold">
          Step-by-Step Instructions:
        </Typography>
        <List sx={{ pl: 2 }}>
          {instructions.map((instruction, index) => (
            <ListItem key={index} sx={{ py: 1, px: 0, alignItems: 'flex-start' }}>
              <Box
                sx={{
                  minWidth: 28,
                  height: 28,
                  borderRadius: '50%',
                  backgroundColor: '#514387',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  fontSize: 14,
                  mr: 2,
                  flexShrink: 0,
                }}
              >
                {index + 1}
              </Box>
              <ListItemText
                primary={instruction}
                primaryTypographyProps={{
                  variant: 'body1',
                  sx: { lineHeight: 1.8 },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Additional help link */}
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Need more help?
        </Typography>
        <Button
          variant="outlined"
          startIcon={<OpenInNewIcon />}
          onClick={openHelpURL}
          sx={{ mt: 1 }}
        >
          View Official Browser Guide
        </Button>
      </Box>
    </Box>
  )
}

export default BrowserSpecificHelp


















